import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_button_source = _resolveComponent("miezz-button-source")!

  return (_openBlock(), _createBlock(_component_miezz_button_source, {
    model: _ctx.button,
    onHandleSourceClick: _ctx.handleMessageBoxClick
  }, null, 8, ["model", "onHandleSourceClick"]))
}